export default __webpack_public_path__ + "static/media/iconnecro.de1fed25.png";